<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{ $t("purchases.productFound") }}
      </p>
    </header>

    <section class="modal-card-body">
      <p class="has-text-centered">
        {{ $t("purchases.informProductCost") }}
      </p>
      <br />

      <b-table :data="[product]" narrowed id="products-table">
        <b-table-column field="b" :label="$t('purchases.code')" v-slot="props">
          {{ props.row.b }}
        </b-table-column>

        <b-table-column field="n" :label="$t('common.name')" v-slot="props">
          {{ props.row.n }}
        </b-table-column>

        <b-table-column :label="$t('purchases.cost')">
          <money
            v-model="lc"
            v-bind="money"
            class="input"
            style="width: 150px"
          ></money>
        </b-table-column>
      </b-table>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>

      <button
        class="button"
        :style="{
          backgroundColor: $primaryColor,
          color: $primaryColorContrast
        }"
        type="button"
        @click="addToPurchases"
      >
        {{ $t("purchases.add") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Money } from "v-money";
import { common } from "../../mixins/common";

export default {
  props: ["product"],

  mixins: [common],

  components: {
    Money
  },

  data() {
    return {
      lc: 0,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2
      }
    };
  },

  methods: {
    addToPurchases() {
      if (!this.lc) {
        this.alertError({ message: "INVALID_PRICE" });
        return;
      }
      const lc = Number(String(this.lc.toFixed(2)).replace(/[^0-9]+/g, ""));
      this.$emit("add-product-to-purchases", {
        product: {
          ...this.product,
          lc
        }
      });
    }
  },

  computed: {
    ...mapGetters(["scaleProductsBase", "permissions", "payments"])
  },

  mounted() {
    this.money.prefix = `${this.payments.currencySymbol} `;
  }
};
</script>
